<footer class="footer" id="footer">
  <div class="container mb-6">
    <main class="row section-inset-t">
      <div class="col-lg-7 col-md-12 mb-3 mb-md-0">
        <img class="footer-logo mb-4" [src]="'footer:logo-url' | fromDictionary" [alt]="'meta-titel' | fromDictionary" />
        <div class="d-flex flex-column gap-4">
          <ul class="contact-info-list">
            <li class="contact-info-list__item">
              <a [href]="'contact:adresregel-link' | fromDictionary" target="_blank" class="button button-link button--light fw-normal">
                <fstr-icon [anchor]="'icon-map-marker'"></fstr-icon>
                <span>{{ 'contact:adresregel' | fromDictionary }}</span>
              </a>
            </li>
            <li class="contact-info-list__item">
              <a [href]="'tel:' + ('contact:telefoonnummer' | fromDictionary)" class="button button-link button--light fw-normal">
                <fstr-icon [anchor]="'icon-phone'"></fstr-icon>
                <span>{{ 'contact:telefoonnummer' | fromDictionary }}</span>
              </a>
            </li>
            <li class="contact-info-list__item">
              <a
                [href]="'mailto:' + ('contact:emailadres' | fromDictionary)"
                target="_blank"
                class="button button-link button--light fw-normal"
              >
                <fstr-icon [anchor]="'icon-envelope'"></fstr-icon>
                <span>{{ 'contact:emailadres' | fromDictionary }}</span>
              </a>
            </li>
          </ul>

          <ul class="financial-info-list">
            <li class="financial-info-list__item">
              <span>{{ 'footer:makelaardij-bedrijfsnaam' | fromDictionary }}</span>
              <div>
                <span class="financial-info-list__abbreviation">BTW</span>
                <span>{{ 'footer:makelaardij-btw-nummer' | fromDictionary }}</span>
              </div>
              <div>
                <span class="financial-info-list__abbreviation">KVK</span>
                <span>{{ 'footer:makelaardij-kvk-nummer' | fromDictionary }}</span>
              </div>
            </li>
            <li class="financial-info-list__item mt-4">
              <span>{{ 'footer:taxaties-bedrijfsnaam' | fromDictionary }}</span>
              <div>
                <span class="financial-info-list__abbreviation">BTW</span>
                <span>{{ 'footer:taxaties-btw-nummer' | fromDictionary }}</span>
              </div>
              <div>
                <span class="financial-info-list__abbreviation">KVK</span>
                <span>{{ 'footer:taxaties-kvk-nummer' | fromDictionary }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-lg-8 col-md-12 my-5 my-md-0">
        <h4 class="mb-2 text-inherit">{{ 'footer:kolom-2-titel' | fromDictionary }}</h4>
        <span class="mb-4 d-block">{{ 'footer:kolom-2-subtitel' | fromDictionary }}</span>
        <ul class="membership-list">
          @for (membership of memberships(); track membership.id) {
            <li class="membership-list__item">
              <a [href]="membership.url" target="_blank" class="button button-icon button--light membership-link">
                <span class="sr-only">{{ membership.title }}</span>

                @let icon = membership.icon || (membership.url | socialIcon);

                @if (membership.imageUrl) {
                  <img [src]="membership.imageUrl" [alt]="membership.title" />
                } @else if (icon) {
                  <fstr-icon [anchor]="icon" [title]="membership.title"></fstr-icon>
                }
              </a>
            </li>
          }
        </ul>
        <span class="fw-bold mt-5 d-block">{{ 'footer:menu-titel' | fromDictionary }}</span>
        <ul class="footer-nav-list">
          @for (page of menu(); track page) {
            <li class="footer-nav-list__item pt-2">
              <fstr-link
                [cssClasses]="'text-decoration-none'"
                [button]="{
                  text: page.title,
                  url: page.url || '',
                  queryParams: page.queryParams || null,
                  routerLink: page.routerLink || null,
                  fragment: page.fragment || null,
                }"
                [routerLinkActive]="'is--active'"
                [routerLinkActiveOptions]="{ exact: page.url === '/' }"
                [showText]="false"
              >
                <span class="text-gray-200">{{ page.title }}</span>
              </fstr-link>
            </li>
          }
          <li class="footer-nav-list__item pt-2">
            <button (click)="openCookie()">
              {{ 'cookiemelding:cookie-settings' | fromDictionary }}
            </button>
          </li>
        </ul>
      </div>
      <div class="col-lg-8 offset-lg-1 col-md-12 mt-lg-0">
        @let whatsapp = 'contact:whatsapp-nummer' | fromDictionary: false;
        @if (whatsapp) {
          <a class="d-flex align-items-center gap-3 link-reset mb-4" [href]="'https://wa.me/' + whatsapp" target="_blank">
            <span class="button button-icon button--secondary">
              <fstr-icon [anchor]="'icon-whatsapp'"></fstr-icon>
            </span>
            <span class="fw-bold d-flex flex-column">
              {{ 'footer:whatsapp-cta-tekst' | fromDictionary }}
            </span>
          </a>
        }
        <span class="fs-body-sm fw-bold mb-3 d-block">{{ 'footer:social-volg-ons-label' | fromDictionary }}</span>
        <app-social-channel-buttons [channels]="socials()"></app-social-channel-buttons>
      </div>
    </main>
  </div>

  <a [routerLink]="'/'" class="footer-big-logo">
    <img width="200" height="74" [src]="'/assets/gfx/muller-logo-wit.svg'" [alt]="'meta-titel' | fromDictionary" />
  </a>

  <!-- <ul class="footer__nav-list pt-5 d-flex gap-3 pb-3">
    <li class="footer__nav-list__item">{{ year }} &copy; {{ 'overig:meta-titel-suffix' | fromDictionary }}</li>
  </ul> -->
</footer>
